import React from "react";
import "./innerChaos.scss";
import ImageZoom from "components/imageZoom/ImageZoom";
import innerChaosCover from "assets/img/home/innerChaos/innerChaosCover.webp";
import innerChaosCoverMob from "assets/img/home/innerChaos/innerChaosCoverMob.webp";
import innerChaos1 from "assets/img/home/innerChaos/innerChaos1.webp";
import innerChaos2 from "assets/img/home/innerChaos/innerChaos2.webp";
import innerChaos3 from "assets/img/home/innerChaos/innerChaos3.webp";
import { Link, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { INNER_CHAOS_ID } from "constant";
import productStore from "store/productStore";
import cartStore from "store/cartStore";
import { useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import authStore from "store/authStore";
import ImageSlider from "../imageSlider/ImageSlider";
import imageLoadStore from "store/imageLoadStore";

const InnerChaos = () => {
  const ImageLoadStore = imageLoadStore();
  const navigate = useNavigate();

  const ProductStore = productStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const [product, setProduct] = useState(null);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [isAddToCart, setIsAddToCart] = useState(false);

  useEffect(() => {
    fetchSpecificProductRating();
  }, []);

  const fetchSpecificProductRating = async () => {
    const product = await ProductStore.fetchOneProduct({
      _id: INNER_CHAOS_ID,
    });
    setProduct(product);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <div className="inner-chaos-home">
      <div className="first-container">
        <div className="image-container">
          <img src={innerChaosCoverMob} alt="inner-chaos-perfume-background" />
        </div>

        <div className="text-container">
          <div className="text-wrapper">
            <h2>Inner Chaos</h2>
            <div className="quote-container">
              <q>Beautifully Addictive. Wildly You.</q>
              <p>
                Inner Chaos is a sweet yet intense fragrance combining coffee,
                vanilla, and soft florals, delivering an addictive and modern
                scent that lingers with warmth and confidence.
              </p>
            </div>
            <div className="button-container">
              <Link
                to={`/perfume/inner-chaos/${INNER_CHAOS_ID}/details`}
                className="link learn-more-link"
                onClick={() => {
                  ImageLoadStore.setImageLoading(true);
                }}
              >
                Learn More
              </Link>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy-now"
              >
                Buy Now
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <div className="second-container">
        <div className="left-container">
          <div className="image-container">
            <div className="left-image img-content">
              <ImageZoom src={innerChaos2} alt="inner-chaos-left" />
            </div>
          </div>
          <div className="quote-content">
            <q>
              Sweet coffee perfume, vanilla gourmand scent, bold evening
              fragrance, addictive signature scent.
            </q>
          </div>
        </div>
        <div className="right-container">
          <div className="image-container">
            <div className="right-move-container">
              <div className="right-first-image img-content">
                <ImageZoom src={innerChaos1} alt="inner-chaos-first-right" />
              </div>
            </div>
            <div className="right-second-image img-content">
              <ImageZoom src={innerChaos3} alt="inner-chaos-second-right" />
            </div>
          </div>
        </div>
      </div>
      <ImageSlider
        alt="inner-chaos"
        images={[innerChaos1, innerChaos2, innerChaos3]}
        quoteText={
          "Sweet addictive perfume, bold coffee-vanilla scent, warm and long-lasting."
        }
      />
    </div>
  );
};

export default InnerChaos;
